export const REOPEN_BRAND_CURATION_TASK = {
  START: 'START_REOPEN_BRAND_CURATION_TASK',
  COMPLETE: 'COMPLETE_REOPEN_BRAND_CURATION_TASK',
  FAIL: 'FAIL_REOPEN_BRAND_CURATION_TASK',
}

export const FETCH_BRAND_CURATION_TASK = {
  START: 'START_FETCH_BRAND_CURATION_TASK',
  COMPLETE: 'COMPLETE_FETCH_BRAND_CURATION_TASK',
  FAIL: 'FAIL_FETCH_BRAND_CURATION_TASK',
  CLEANUP: 'CLEANUP_FETCH_BRAND_CURATION_TASK',
}

export const UPDATE_BRAND_CURATION_TASK = {
  START: 'START_UPDATE_BRAND_CURATION_TASK',
  COMPLETE: 'COMPLETE_UPDATE_BRAND_CURATION_TASK',
  FAIL: 'FAIL_UPDATE_BRAND_CURATION_TASK',
}

export const UPDATE_BRAND_CURATION_TASK_STATUS_FLAG = {
  START: 'START_UPDATE_BRAND_CURATION_TASK_STATUS_FLAG',
  COMPLETE: 'COMPLETE_UPDATE_BRAND_CURATION_TASK_STATUS_FLAG',
  FAIL: 'FAIL_UPDATE_BRAND_CURATION_TASK_STATUS_FLAG',
}

export const UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND = {
  START: 'START_UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND',
  COMPLETE:
    'COMPLETE_UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND',
  FAIL: 'FAIL_UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND',
}

export const DUPLICATE_BRAND_CURATION_TASK = {
  START: 'START_DUPLICATE_BRAND_CURATION_TASK',
  COMPLETE: 'COMPLETE_DUPLICATE_BRAND_CURATION_TASK',
  FAIL: 'FAIL_DUPLICATE_BRAND_CURATION_TASK',
}
